const translations = {
  title: 'Trigger history',
  name: 'Name',
  status: 'Status',
  originEntity: 'Origin entity',
  destinationEntity: 'Destination entity',
  date: 'Date',
  idLabel: 'ID: {{id}}',
  triggerFired: 'Trigger fired',
  cardsViewComingSoon: 'Cards view (coming soon)',
  seeDetails: 'See details',
  runManually: 'Run manually',
  confirmRetry: 'Are you sure you want to run again?',
  'tabs.result': 'Result',
  'tabs.payload': 'Payload',
  'tabs.entity': 'Entity',
  'tabs.trigger': 'Trigger',
  'tabs.rest': 'Rest'
}

export default translations
